import { isDesktop, isIos, isAndroid } from "@/lib/web";
import { APP_STORE_BADGES } from "@/lib/app_store_badges";
import { APP_STORE_LINKS } from "@/lib/globals";
import { getEffectiveUiLanguage } from "@/l11n/l11n";
import { postEvent } from "@/lib/api_controller";
import { TaaliaEvent } from "@/lib/event_types";

export default function AppStoreBadges() {
  const lang = getEffectiveUiLanguage().toUpperCase();

  const appStoreBadge = APP_STORE_BADGES[`app_store_badge_${lang}`];
  const playStoreBadge = APP_STORE_BADGES[`play_store_badge_${lang}`];
  const appStoreLink = APP_STORE_LINKS.ios;
  const playStoreLink = APP_STORE_LINKS.android;

  return (
    <div className="flex flex-col items-center text-center p-4">
      {(isIos || isDesktop) && <BadgeLink href={appStoreLink} img={appStoreBadge} />}
      {(isAndroid || isDesktop) && (
        <BadgeLink href={playStoreLink} img={playStoreBadge} />
      )}
    </div>
  );
}

const BadgeLink = ({ href, img }) => (
  <a
    href={href}
    target={isDesktop ? "_blank" : "_self"}
    rel="noreferrer"
    className="mb-2"
    onClick={() => postEvent(TaaliaEvent.appStoreBadgeClicked)}
  >
    <img src={img} alt="Store Badge" className="w-[200px]" />
  </a>
);
